import { useCallback, useState } from 'react';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { PhotoCredits } from './components/PhotoCredits';
import { HomePage } from './pages/HomePage';
import { PrivacyPage } from './pages/PrivacyPage';
import { DeleteAccountPage } from './pages/DeleteAccountPage';
import { AndroidPage } from './pages/AndroidPage';
import { TeamGuidePage } from './pages/TeamGuidePage';
import { ROUTES, useRoute } from './router';

const PAGES = {
  [ROUTES.privacy]: PrivacyPage,
  [ROUTES.deleteAccount]: DeleteAccountPage,
  [ROUTES.android]: AndroidPage,
  [ROUTES.teamGuide]: TeamGuidePage,
};

export default function App() {
  const [creditsOpen, setCreditsOpen] = useState(false);
  const route = useRoute();

  const openCredits = useCallback(() => setCreditsOpen(true), []);
  const closeCredits = useCallback(() => setCreditsOpen(false), []);

  // An unknown path falls back to the homepage rather than a dead screen; the
  // routes above are the only addresses this site publishes.
  const Page = PAGES[route];

  return (
    <>
      <a className="tl-skip-link" href="#main">
        Skip to content
      </a>

      <SiteHeader route={route} />

      <main id="main">{Page ? <Page /> : <HomePage />}</main>

      <SiteFooter onOpenCredits={openCredits} route={route} />

      <PhotoCredits open={creditsOpen} onClose={closeCredits} />
    </>
  );
}
